import React from 'react';
import './MoneyLeaks.css';

const MoneyLeaks = () => {
  const leaks = [
    {
      icon: '📞',
      title: 'Missed Calls = Ghost Revenue',
      description: 'Calls that ring into the void. Bookings that never happen. Revenue you\'ll never recover.',
      alert: true
    },
    {
      icon: '📅',
      title: 'Staffing by Intuition',
      description: 'Schedules built on habit, not demand.',
      alert: true
    },
    {
      icon: '🔗',
      title: 'Disconnected Systems',
      description: 'Calls, bookings, and payments don\'t tell the same story.',
      alert: true
    },
    {
      icon: '💅',
      title: 'Add-Ons Left to Chance',
      description: 'Opportunities depend on memory, not consistency.',
      alert: true
    },
    {
      icon: '🏢',
      title: 'Multi-Location Blind Spots',
      description: 'One location thrives while another quietly struggles.',
      alert: true
    }
  ];

  return (
    <section id="money-leaks" className="money-leaks-section">
      <div className="container">
        <h2 className="section-title">
          Where salons lose money — without realizing it
        </h2>

        <div className="leaks-grid">
          {leaks.map((leak, index) => (
            <div key={index} className="leak-card">
              {leak.alert && <div className="alert-dot"></div>}
              <div className="leak-icon">{leak.icon}</div>
              <h3 className="leak-title">{leak.title}</h3>
              <p className="leak-description">{leak.description}</p>
            </div>
          ))}
        </div>

        <p className="leaks-footer">
          We make these moments visible — and actionable.
        </p>
      </div>
    </section>
  );
};

export default MoneyLeaks;
